const scope = 'components/SecuredImage/';
export const GET_IMAGE = `${scope}GET_IMAGE`;
export const SET_IMAGE = `${scope}SET_IMAGE`;
